import React, { FunctionComponent, ReactElement, useState } from 'react';
import PanoramicInterior from '../panoramicInterior/PanoramicInterior';
import Image360 from '../image360/Image360';
import { ImageType } from '../../../../../gqlCommon/enum/ImageType';
import MinimalLoader from '../../../../../common/components/presentation/MinimalLoader';
import Image from 'material-ui-image';
import ThreeSixtyViewToggle from '../threeSixtyViewToggle/ThreeSixtyViewToggle';
import { Box } from '@material-ui/core';
export interface IThreeSixtyContainerProps {
  loading: boolean;
  hasInterior: boolean;
  interiorImageUrl: string;
  exteriorImagesUrls: string[];
  titleComponent: ReactElement;
}

const ThreeSixtyContainer: FunctionComponent<IThreeSixtyContainerProps> = ({
  loading,
  hasInterior,
  interiorImageUrl,
  exteriorImagesUrls,
  titleComponent,
}) => {
  const [displayType, setDisplayType] = useState(ImageType.EXTERIOR_360);

  if (loading && !interiorImageUrl && !exteriorImagesUrls.length) {
    return <MinimalLoader />;
  }

  return (
    <>
      <Box position="relative">
        <ThreeSixtyViewToggle displayType={displayType} setDisplayType={setDisplayType} />
      </Box>
      {titleComponent}
      {displayType === ImageType.INTERIOR_360_PANORAMIC ? (
        hasInterior ? (
          <PanoramicInterior interiorImageUrl={interiorImageUrl} />
        ) : (
          <Image
            src={interiorImageUrl}
            color="transparent"
            animationDuration={0}
            imageStyle={{ height: '100%', width: '100%', maxHeight: 'unset', objectFit: 'cover', overflow: 'hidden' }}
            aspectRatio={2.3}
            data-test="image_display:interior"
            alt=""
          />
        )
      ) : (
        <Image360 exteriorImagesUrls={exteriorImagesUrls} />
      )}
    </>
  );
};

export default ThreeSixtyContainer;
